// extracted by mini-css-extract-plugin
export default {"simpleSpin":"style_simpleSpin__fAZK+"};